import { useState } from 'react';
import { GatewayCard } from '../components/GatewayCard/GatewayCard';
import { getGatewayTheme } from '../constants/gateway.themes';
import type { Gateway } from '../types/gateway.types';
import mockData from '../services/gateways.mock.json';
import styles from './PaymentGatewaysPage.module.css';

const toActiveMap = (gateways: Gateway[]): Record<number, boolean> =>
	Object.fromEntries(gateways.map((g) => [g.id, g.status === 'ativo']));

export const PaymentGatewaysPage = () => {
	const [gateways] = useState<Gateway[]>(mockData.gateways as Gateway[]);
	const [activeMap, setActiveMap] = useState<Record<number, boolean>>(() => toActiveMap(mockData.gateways as Gateway[]));

	const handleToggle = (id: number, active: boolean) => {
		setActiveMap((prev) => ({ ...prev, [id]: active }));
	};

	return (
		<div className={styles.page}>

			<div className={styles.grid}>
				{gateways.map((gateway) => (
					<GatewayCard
						key={gateway.id}
						gateway={gateway}
						theme={getGatewayTheme(gateway.slug)}
						isActive={activeMap[gateway.id] ?? false}
						onToggle={handleToggle}
					/>
				))}
			</div>
		</div>
	);
};
